// AdminRoute.tsx
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

export function AdminRoute({ children }) {
  const { currentUser, loading, isAdmin } = useAuth();

  if (loading) {
    // You can render a spinner or skeleton
    return <div>Loading...</div>;
  }

  if (!currentUser || !isAdmin) {
    // If user not logged in or not admin, redirect
    return <Navigate to="/" replace />;
  }

  return children;
}
